import { createApp } from "vue";

const install = (app) => {
  app.directive("draggable", {
    mounted(el, binding, vnode) {
      let isDragging = false;
      let x = 0;
      let y = 0;
      let maxX = 0;
      let maxY = 0;
      let windowsHeight = document.getElementById('app').clientHeight;

      el.style.position = "absolute";

      el.addEventListener("mousedown", (e) => {
        // 设置鼠标指针
        if (e.target.classList.contains("page-header")) {
          isDragging = true;
          x = e.pageX - el.offsetLeft;
          y = e.pageY - el.offsetTop;
          //  限制拖拽范围
          // maxX = el.parentNode.offsetWidth - el.offsetWidth;
          // maxY = el.parentNode.offsetHeight - el.offsetHeight;
          maxX = Infinity;
          maxY = Infinity;
          // maxY = 0
          el._draggable = true;
          el.style.cursor = "move";
        }
      });

      document.addEventListener("mousemove", (e) => {
        if (isDragging && el._draggable) {
          windowsHeight = document.getElementById('app').clientHeight

          el.style.transitionProperty = "none";
          el.style.opacity = 0.9;
          // 限制不能拖拽出窗口最左边和最上边
          // let left = e.pageX - x;
          // let top = e.pageY - y;
          // left = Math.max(0, Math.min(left, maxX));

          let left = e.pageX - x;
          let top = e.pageY - y;
          // top = Math.max(0, Math.min(top, maxY));


          //  限制不能拖拽出窗口最上边 && 不能拖拽出窗口最下边
          top = Math.max(-8, Math.min(top, windowsHeight - 48));

          el.style.left = left + "px";
          el.style.top = top + "px";

          let childNode = el.firstElementChild;
          if (childNode) {
            childNode.style.boxShadow = "1px -1px 8px 1px #4F46BA";
          }
        }
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
        el._draggable = false;
        el.style.cursor = "default";
        el.style.transitionProperty = "opacity,width,height,padding";
        el.style.opacity = 1;

        let childNode = el.firstElementChild;
        if (childNode) {
          childNode.style.boxShadow =
              "0 0 0 2px var(--el-input-border-color, var(--el-border-color)) inset";
        }
      });
    },
  });
};

export default {
  install,
};
